import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_ALL_STATE, GET_USER_EMAIL, SET_LOADING, SET_USER_EMAIL, SET_USER_STEP, SET_USER_TAB } from "@/store/slices/appSlice";
import Button from "@/components/inputs/button";
import ButtonLink from "@/components/inputs/buttonLink";
import InputWithValidation from "@/components/inputs/inputWithValidation";
import { useCookies } from "react-cookie";
import { SET_USER, SET_USER_ALERT } from "@/store/slices/userSlice";
import SimpleText from "@/components/texts/simpleText";
import themes from "@/styles/themes";
import Events from "@/utils/Events";
import ButtonLinkUndescore from "@/components/inputs/buttonLinkUnderscore";
import Lead from "@/utils/Lead";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import Apm from "@/utils/Apm";
import { login, validateEmailRegister } from "@/api/assine";
import Nullable from "@/types/utils/Nullable";
import { isEmail } from "@/utils/validation";
import { getRemainingTries, userCanTryToLogin, addFailedTry } from "@/utils/login-limiter";
import { safeDecode } from "@/utils/cookies";

export default function Autenticar() {

    const events = new Events();
    const setCookie = useCookies()[1];
    const dispatch = useDispatch();
    const states = useSelector(GET_ALL_STATE)
    const offer_type = useSelector(GET_OFFER_TYPE)
    const storedEmail = useSelector(GET_USER_EMAIL)
    const [all_states, setStates] = useState(states)
    const [email, setEmail] = useState(storedEmail)
    const [password, setPassword] = useState('')
    const [emailErrorMessage, setEmailErrorMessage] = useState<Nullable<string>>(null)
    const [passwordErrorMessage, setPasswordErrorMessage] = useState<Nullable<string>>(null)
    const [isEmailValidate, setIsEmailValidate] = useState<boolean>(false);
    const isEmailFocusedRef = useRef(false);

    // useEffect(() => {
    //     if(!userCanTryToLogin()){
    //         setTab(3)
    //     }
    // }, [])

    useEffect(() => {
        setStates(states)
    }, [states]);

    useEffect(() => {
        events.trigger("identificacao_visualizado", { offer_type })
    }, [offer_type]);

    function setTab(idx: number) {
        dispatch(SET_USER_TAB(idx))
    }

    function ValidateTelefone(telefone: any) {
        return telefone && telefone.trim().length >= 8
    }

    async function nextStep(event: any) {
        event.preventDefault()

    if (!isEmailValidate) {
        if (!isEmail(email)) {
            events.trigger('identificacao_erro_email', { offer_type })
            setEmailErrorMessage('Email Inválido')
            return
        }

        try {
            dispatch(SET_LOADING(true))

            const res = await validateEmailRegister(email)

            if (res) {
                setIsEmailValidate(true)
                events.trigger("identificacao_login_visualizado", { offer_type })
            } else {
                dispatch(SET_USER_EMAIL(email))
                setTab(1)
            }
        } catch {
            // mantém comportamento atual
            setIsEmailValidate(true)
        } finally {
            dispatch(SET_LOADING(false))
        }

        return
    }

        let erroNoFormulario: boolean = false

        if (!isEmail(email)) {
            erroNoFormulario = true
            events.trigger('identificacao_login_erro_email', { offer_type })
            setEmailErrorMessage('Email Inválido')
        }

        if (password.length === 0) {
            if (isEmailValidate) {
                erroNoFormulario = true
                events.trigger('identificacao_login_erro_senha', { offer_type })
                setPasswordErrorMessage('Senha Inválida')
            }
        }

        if (erroNoFormulario) {
            return
        }

        setEmailErrorMessage('')
        setPasswordErrorMessage('')

        try {
            dispatch(SET_LOADING(true));
            login({
                email: email.trim(),
                password
            }).then((res) => {
                if (res && res.id) {
                    let user_data = {
                        email: res.email,
                        id: res.id,
                        telefone: res.telefone
                    }

                    if (res.cookies) {
                        try {
                            Object.values(res.cookies).forEach((value: any) => {
                                value.value = safeDecode(value.value);

                                const dia = 24 * 60 * 60 * 1000;
                                const numeroDeDias = 7 * dia;
                                const dataAtual = new Date();
                                dataAtual.setMilliseconds(dataAtual.getMilliseconds() + numeroDeDias)

                                setCookie(value.name, value.value, {
                                    domain: value.domain,
                                    path: value.path,
                                    secure: true,
                                    expires: dataAtual
                                });

                                if (value.name === 'OESP_INFO') {
                                    user_data = {
                                        ...user_data,
                                        ...JSON.parse(value.value)
                                    }
                                }
                            })
                        } catch (error) {
                            Apm.captureError(`AUTENTICAR_SET_COOKIE: ${error}`)
                        }
                    }

                    if (!ValidateTelefone(user_data.telefone)) {
                        dispatch(SET_USER_STEP(1))
                    } else {
                        dispatch(SET_USER_STEP(2))
                    }


                    dispatch(SET_USER({
                        email: user_data.email,
                        id_usuario: user_data.id
                    }))
                    events.trigger("identificacao_login_sucesso", { offer_type })
                    Lead.save(all_states.lead.value, dispatch)
                }
            }).catch((error) => {
                Apm.captureError(`Autenticar() -> nextStep(): ${error}`);
                events.trigger("identificacao_login_error", { offer_type })
                if (error && error.toLowerCase().includes('network')) {
                    error = 'Erro de conexão'
                }
                if (error && error.toLowerCase().includes('request failed')) {
                    error = 'Ops, tente novamente!'
                }
                dispatch(SET_USER_ALERT({ show: true, message: error, type: 'error' }))
                // addFailedTry()
                /*const remainingTries = getRemainingTries()

                if(remainingTries > 0){
                    dispatch(SET_USER_ALERT({show: true, message: `falha no login você tem mais ${remainingTries} tentativas`, type: 'error'}))
                }else{
                    dispatch(SET_USER_ALERT({show: true, message: 'Você esgotou suas tentativas de login', type: 'error'}))
                    setTab(3)
                }*/
            })
                .finally(() => {
                    dispatch(SET_LOADING(false))
                })
        } catch (error: any) {
            Apm.captureError(`AUTENTICAR: ${error}`);
            dispatch(SET_USER_ALERT({ show: true, message: error.message, type: 'error' }))
        }
    }


    return <>
        <div onClick={() => dispatch(SET_USER_ALERT({ show: false }))} >
            {/* <SimpleText color={themes.greyNormal} style={{ margin: '6px 0' }}>
                Não possui uma conta?{' '}
                <ButtonLink
                    color={`${themes.estadao} !important`}
                    style={{ textDecoration: 'underline', fontSize: '13px' }}
                    onClick={() => {
                        events.trigger("identificacao_login_cadastre_se", { offer_type })
                        setTab(0)
                    }}
                >
                    Cadastre-se.
                </ButtonLink>
            </SimpleText> */}
            <form onSubmit={nextStep}>
                <div>
                <InputWithValidation
                    type={'email'}
                    name={'email'}
                    id={'email'}
                    placeholder={'E-mail'}
                    OnClick={() => {
                        isEmailValidate ? events.trigger("identificacao_login_email", { offer_type }) : events.trigger("identificacao_email", { offer_type })
                        setEmailErrorMessage(null)
                    }}                 
                    errorMessage={emailErrorMessage}
                    onFocus={() => { isEmailFocusedRef.current = true }}
                    onBlur={() => { isEmailFocusedRef.current = false }}
                    onChange={(value: string) => {
                    setEmail(value)
                        if (isEmailValidate && isEmailFocusedRef.current) {
                            setIsEmailValidate(false)
                            setPassword('')
                            setPasswordErrorMessage(null)
                        }
                    }}
                    value={email}
                />
                </div>
                {isEmailValidate && (
                    <>
                        <div>
                            <InputWithValidation
                                type={'password'}
                                name={'password'}
                                id={'password'}
                                placeholder={'Senha'}
                                OnClick={() => {
                                        events.trigger("identificacao_login_senha", { offer_type }),
                                            setPasswordErrorMessage(null)
                                }}
                                errorMessage={passwordErrorMessage}
                                onChange={setPassword}
                                value={password}
                            />
                        </div>
                        <div className={'text--right forget-password'} >
                            <ButtonLinkUndescore type="button" onClick={() => {
                                dispatch(SET_USER_EMAIL(email))
                                setTab(3)
                                events.trigger("identificacao_login_esqueci_minha_senha", { offer_type })
                            }} color={themes.estadao} style={{ width: 'none' }}>
                                Esqueci a minha senha
                            </ButtonLinkUndescore>
                        </div>
                    </>
                )}
                <div>
                    <Button data-transaction-name="Logar Usuario" type={'submit'} onClick={() => {
                        if (isEmailValidate) {
                            events.trigger("identificacao_login_continuar", { offer_type })
                        } else {
                            events.trigger("identificacao_continuar", { offer_type })
                        }
                    }}>Continuar</Button>
                </div>
            </form>
        </div>
    </>
}
